import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getFAQAction, getPrivacyPolicyAction, getTermsAndConditionsAction } from './terms-and-conditions.actions';
import { ITermsAndConditionsFeature } from './terms-and-conditions.feature.state';
import { getFAQContent, getIsLoading, getPrivacyPolicyContent, getTermsAndConditionsContent } from './terms-and-conditions.selectors';

@Injectable()
export class TermsAndConditionsFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public termsAndConditionsContent$ = this.store.select(getTermsAndConditionsContent);
  public faqContent$ = this.store.select(getFAQContent);
  public privacyPolicyContent$ = this.store.select(getPrivacyPolicyContent);

  constructor(private store: Store<ITermsAndConditionsFeature>) {}

  public getTermsAndConditions(): void {
    this.store.dispatch(getTermsAndConditionsAction());
  }

  public getFAQ(): void {
    this.store.dispatch(getFAQAction());
  }

  public getPrivacyPolicy(): void {
    this.store.dispatch(getPrivacyPolicyAction());
  }
}
